export default function CharlottesWebAudition() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Charlotte&apos;s Web
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<h3 className="font-bold">Audition Information</h3>
					<p>
						Calling all actors! East Bloomfield Historical Society is
						holding auditions for our upcoming production of
						Charlotte&apos;s Web! This is a special 50-minute version of
						the play (not a musical) with a small but expandable cast.
						The most enchanting characters are here: Wilbur, the
						irresistible young pig who desperately wants to avoid the
						butcher; Fern, a girl who understands what animals say to
						each other; Templeton, the gluttonous rat who can
						occasionally be talked into a good deed; and, most of all,
						the extraordinary spider, Charlotte, who proves to be
						&ldquo;a true friend and a good writer.&rdquo; Determined to
						save Wilbur, Charlotte begins her campaign with the
						&ldquo;miracle&rdquo; of her web in which she writes,
						&ldquo;Some pig.&rdquo; It&apos;s the beginning of a
						victorious campaign which ultimately ends with the now-safe
						Wilbur doing what is most important to Charlotte. This
						beautiful, knowing play about friendship is a
						classic...perfect for actors of all ages and experience
						levels.
					</p>
					<br />
					<p>
						We are looking for enthusiastic performers of all
						backgrounds, ages 9 and up, to bring these classic characters
						to life. Whether you&apos;re an experienced actor or new to
						the stage, we encourage you to audition!
					</p>
					<br />
					<p>
						Join us in spinning a wonderful tale of friendship, courage,
						and love!
					</p>
					<br />
					<p>
						<span className="font-bold">
							Audition Dates & Times:
						</span>
						<br />
						<ul>
							<li>Sunday, April 27th at 2:00 PM</li>
							<li>Monday, April 28th at 6:00 PM</li>
						</ul>
						<br />
						Location: East Bloomfield Historical Society Academy
						Building, 8 South Ave. East Bloomfield, NY 14443 If you are
						unable to attend on these dates, please reach out--other
						accommodations can be made.
						<br />
						<br />
						Performance Dates: June 13 & 14, 2025 (two performances on
						the 14th)
						<br />
						<br />
						Please out the audition form here{' '}
						<a
							href="https://forms.gle/ZDDomo92HP8qHtP18"
							className="text-blue-600 underline"
						>
							https://forms.gle/ZDDomo92HP8qHtP18
						</a>
						<br />
						<br />
						More information, including audition sides (monologues) can
						be found here{' '}
						<a
							href="https://docs.google.com/document/d/1LlqqNF4txfB8UlaBavs-Sej5pvISK4v0PixCoVaIjvo/edit?usp=sharing"
							className="text-blue-600 underline"
						>
							https://docs.google.com/document/d/1LlqqNF4txfB8UlaBavs-Sej5pvISK4v0PixCoVaIjvo/edit?usp=sharing
						</a>
					</p>
				</div>
			</div>
		</>
	)
}
